import React, { useState, useEffect } from 'react';

const TypewriterText = ({ words = [], delay = 0, speed = 150, wordDelay = 300, onComplete }) => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [displayedWords, setDisplayedWords] = useState([]);
  const [currentText, setCurrentText] = useState('');
  const [currentCharIndex, setCurrentCharIndex] = useState(0);
  const [started, setStarted] = useState(false);
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    const startTimer = setTimeout(() => {
      setStarted(true);
    }, delay);

    return () => clearTimeout(startTimer);
  }, [delay]);

  useEffect(() => {
    if (!started || currentWordIndex >= words.length) {
      if (started && currentWordIndex >= words.length && onComplete && !isComplete) {
        setIsComplete(true);
        // Call onComplete after a small delay to ensure cursor is hidden first
        setTimeout(() => {
          onComplete();
        }, 100);
      }
      return;
    }

    const currentWord = words[currentWordIndex];

    if (currentCharIndex < currentWord.length) {
      const timer = setTimeout(() => {
        setCurrentText(prev => prev + currentWord[currentCharIndex]);
        setCurrentCharIndex(prev => prev + 1);
      }, speed);

      return () => clearTimeout(timer);
    } else {
      // Word complete, move to next word after delay
      const timer = setTimeout(() => {
        setDisplayedWords(prev => [...prev, currentText]);
        setCurrentText('');
        setCurrentCharIndex(0);
        setCurrentWordIndex(prev => prev + 1);
      }, wordDelay);

      return () => clearTimeout(timer);
    }
  }, [currentCharIndex, currentWordIndex, words, speed, wordDelay, started, currentText, onComplete, isComplete]);

  return (
    <span>
      {displayedWords.map((word, idx) => (
        <span key={idx}>{word} </span>
      ))}
      {currentText}
      {currentWordIndex < words.length && (
        <span className="animate-pulse">|</span>
      )}
    </span>
  );
};

export default TypewriterText;
